import Component from './editable.vue'
export default Component
